module.exports = __webpack_public_path__ + "static/img/d3.f15eda81.webp";